











































import vue, {PropType} from 'vue';
import emojis from '@/assets/json/emojis.json';
import {Editor} from '@tiptap/vue-2';

interface EmojiList {
  el: { u: string; }[];
  groupe: number;
}

interface ComponentData {
  dialogEmojiDisplayed: boolean;
  emojisList: null | EmojiList[];
  tabSelected: string;
}

export default vue.extend({
  name: 'SmileyAdd',

  props: {
    editor: {
      required: false,
      type: Object as PropType<Editor | null>,
      default: null,
    },
  },

  data: (): ComponentData => ({
    dialogEmojiDisplayed: false,
    emojisList: null,
    tabSelected: '',
  }),

  computed: {
    emojiIsLoaded(): boolean {
      return !!this.emojisList;
    },
    hasEditor(): boolean {
      return !!this.editor
    }
  },

  created() {
    this.emojisList = JSON.parse(JSON.stringify(emojis));
  },

  methods: {
    onSelectEmoji(i: number, j: number): void {
      if (this.editor === null) {
        this.$emit('emoji-selected', (this.emojisList as EmojiList[])[i].el[j].u);
      } else {
        (this.editor as Editor).commands.insertContent((this.emojisList as EmojiList[])[i].el[j].u);
      }
      this.dialogEmojiDisplayed = false;
    },
  },
});
